module.exports = __webpack_public_path__ + "static/img/20170626_133448.667c767.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-ajto/20170626_133448.jpg
// module id = 558
// module chunks = 0